import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getTempList } from "@/api/temp";
export var tempList = {
  namespaced: true,
  state: {
    isInit: 0,
    tempKv: {}
  },
  mutations: {
    setTempKv: function setTempKv(state, tempMap) {
      state.isInit = 1;
      state.tempKv = tempMap;
    }
  },
  actions: {
    getTemp: function getTemp(_ref, e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, tempMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return getTempList({
                page: 1,
                pageSize: 9999,
                temp_type: e
              });
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                tempMap = {};
                res.data.list.forEach(function (val) {
                  tempMap[val.id] = val.temp_name;
                });
                commit("setTempKv", tempMap);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    tempMap: function tempMap(state) {
      return state.tempKv;
    }
  }
};